class DayNightBenefits {
  constructor(parent) {
    if (!parent) return;

    this.parent = parent;
    this.sectionId = parent.dataset.sectionId;

    this.mainSliderEl = parent.querySelector('.day-night-benefits-slider-js');
    this.thumbsSliderEl = parent.querySelector('.day-night-benefits-thumbs-js');

    this.mainSwiper = null;
    this.thumbsSwiper = null;
    this.desktopInterval = null;
    this.currentIndex = 0;
    this.gridEl = parent.querySelector('.day-night-benefits-grid');

    this.init();
  }

  init() {
    if (!this.mainSliderEl) return;

    this.initThumbs();
    this.initMainSlider();
    this.startDesktopInterval();

    window.addEventListener('resize', () => {
      if (this.isDesktop()) {
        if (!this.desktopInterval) {
          this.startDesktopInterval();
        }
      } else {
        this.stopDesktopInterval();
      }
    });
  }

  isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  startDesktopInterval() {
    if (!this.gridEl || !this.isDesktop()) return;

    const delay =
      parseInt(this.gridEl.dataset.desktopDelay)
      console.log(delay,'delay');

    const cards = this.gridEl.querySelectorAll('.day-night-benefit-card');
    if (!cards.length) return;

    // Initial active
    cards.forEach(card => card.classList.remove('is-active'));
    cards[0].classList.add('is-active');

    this.desktopInterval = setInterval(() => {
      cards[this.currentIndex].classList.remove('is-active');

      this.currentIndex =
        (this.currentIndex + 1) % cards.length;

      cards[this.currentIndex].classList.add('is-active');
    }, delay);
  }

  stopDesktopInterval() {
    if (this.desktopInterval) {
      clearInterval(this.desktopInterval);
      this.desktopInterval = null;
      this.currentIndex = 0;
    }
  }


  initThumbs() {
    if (!this.thumbsSliderEl) return;

    this.thumbsSwiper = new Swiper(this.thumbsSliderEl, {
      slidesPerView: 3,
      spaceBetween: 12,
      freeMode: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
    });
  }

  initMainSlider() {
    const autoplayEnabled = this.mainSliderEl.dataset.autoplay === 'true';
    const autoplayDelay =
      parseInt(this.mainSliderEl.dataset.autoplayDelay, 10) || 3000;
    const loopEnabled = this.mainSliderEl.dataset.loop === 'true';

    const config = {
      slidesPerView: 1.5,
      spaceBetween: 0,
      speed: autoplayDelay,
      loop: loopEnabled,
      centeredSlides: true,
    };

    if (this.thumbsSwiper) {
      config.thumbs = {
        swiper: this.thumbsSwiper,
      };
    }

    if (autoplayEnabled) {
      config.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
      };
    }

    this.mainSwiper = new Swiper(this.mainSliderEl, config);
  }

  destroy() {
    if (this.mainSwiper) {
      this.mainSwiper.destroy(true, true);
      this.mainSwiper = null;
    }

    if (this.thumbsSwiper) {
      this.thumbsSwiper.destroy(true, true);
      this.thumbsSwiper = null;
    }
  }

  static initAll() {
    document
      .querySelectorAll('.day-night-benefits')
      .forEach(section => {
        if (!section.__dayNightInstance) {
          section.__dayNightInstance = new DayNightBenefits(section);
        }
      });
  }
}

/* ================= INITIAL LOAD ================= */
document.addEventListener('DOMContentLoaded', () => {
  DayNightBenefits.initAll();
});

/* ================= THEME EDITOR SUPPORT ================= */
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', event => {
    const section = document.querySelector(
      `[data-section-id="${event.detail.sectionId}"]`
    );

    if (section && section.classList.contains('day-night-benefits')) {
      section.__dayNightInstance = new DayNightBenefits(section);
    }
  });

  document.addEventListener('shopify:section:unload', event => {
    const section = document.querySelector(
      `[data-section-id="${event.detail.sectionId}"]`
    );

    if (section && section.__dayNightInstance) {
      section.__dayNightInstance.destroy();
      delete section.__dayNightInstance;
    }
  });
}
